(function(){
function init(r){
  if(r.getAttribute('data-on'))return;r.setAttribute('data-on','1');
  var t=r.querySelector('.sl__track'),s=[].slice.call(r.querySelectorAll('.sl__s')),n=s.length,i=0,tm,
  d=[].slice.call(r.querySelectorAll('[data-go]')).filter(function(e){var v=e.getAttribute('data-go');return v!=='prev'&&v!=='next'}),
  ct=r.querySelector('[data-count]'),
  fade=r.getAttribute('data-fx')==='fade',sp=+r.getAttribute('data-speed')||5000,
  auto=r.getAttribute('data-autoplay')==='true'&&!matchMedia('(prefers-reduced-motion:reduce)').matches;
  if(n<2)return;
  function dots(){
    d.forEach(function(e){if(+e.getAttribute('data-go')===i)e.setAttribute('aria-current','true');else e.removeAttribute('aria-current')});
    if(ct)ct.textContent=(i+1)+' / '+n;
    var a=r.querySelector('.pd__th [aria-current]');
    if(a){var p=a.parentNode;p.scrollTo({left:a.offsetLeft-p.clientWidth/2+a.clientWidth/2,top:a.offsetTop-p.clientHeight/2+a.clientHeight/2,behavior:'smooth'})}
  }
  function show(k){
    i=(k+n)%n;
    if(fade){s.forEach(function(e,x){e.classList.toggle('is-on',x===i)})}
    else{t.scrollTo({left:i*t.clientWidth,behavior:'smooth'})}
    dots();
  }
  function stop(){clearInterval(tm)}
  function play(){stop();if(auto&&!document.hidden){tm=setInterval(function(){show(i+1)},sp)}}
  if(!fade){t.addEventListener('scroll',function(){var k=Math.round(t.scrollLeft/t.clientWidth);if(k!==i&&k>=0&&k<n){i=k;dots()}},{passive:true})}
  r.addEventListener('click',function(e){var b=e.target.closest('[data-go]');if(!b)return;var v=b.getAttribute('data-go');show(v==='next'?i+1:v==='prev'?i-1:+v);play()});
  if(auto){r.addEventListener('mouseenter',stop);r.addEventListener('mouseleave',play);
  r.addEventListener('touchstart',stop,{passive:true});r.addEventListener('touchend',play,{passive:true});
  r.addEventListener('focusin',stop);r.addEventListener('focusout',play);
  document.addEventListener('visibilitychange',function(){document.hidden?stop():play()});}
  dots();play();
}
window.eraSliders=function(){[].forEach.call(document.querySelectorAll('[data-slider]'),init)};
window.eraSliders();
})();